import React from 'react';

import { Descr } from './AvailabilityDescrStyles';

const AvailabilityDescr = ({ availability }) => {
  const inversion = {
    in_stock: 'В наличии',
    on_order: 'Под заказ',
  };

  return availability ? <Descr>{inversion[availability]}</Descr> : null;
};

export default AvailabilityDescr;
